export const modificatorKeys = ["allButtons", "primaryButtons", "primaryButtonsOnHover",
  "minorButtons", "minorButtonsOnHover", "flyingButton",
  "flyingButtonOnHover", "progressTrack", "buttonBack", "inputFields",
  "checkedPlainAnswer", "checkedAnswerCheckbox", "checkedPlainAnswerOnHover", "answerImageOverlay", "answerImageOverlayChecked", "agreementCheckbox",
  "offerMarkedText"
] as const;